import { Play } from "lucide-react";
import { SITE } from "../site";

// PLACEHOLDER: while SITE.playStoreUrl is null this renders a non-linked
// "Coming Soon" button. Once the Google Play listing is live, set
// SITE.playStoreUrl in src/site.js and this becomes a real link.
const PlayStoreButton = ({ variant = "primary", testId = "play-store-button" }) => {
    const base =
        "inline-flex items-center gap-3 rounded-full px-7 py-4 font-medium transition-all duration-300";
    const styles =
        variant === "primary"
            ? "bg-saffron text-white hover:bg-saffron-hover hover:-translate-y-0.5"
            : "border border-cream/30 text-cream hover:border-cream hover:-translate-y-0.5";

    const inner = (
        <>
            <Play className="h-5 w-5 fill-current" />
            <span className="flex flex-col items-start leading-tight">
                <span className="text-[10px] uppercase tracking-[0.18em] opacity-80 font-mono">
                    Coming soon on
                </span>
                <span className="text-base font-semibold font-display tracking-tight">
                    Google Play
                </span>
            </span>
        </>
    );

    if (!SITE.playStoreUrl) {
        return (
            <span
                data-testid={testId}
                role="button"
                aria-disabled="true"
                title="Google Play link placeholder — will be activated at launch"
                className={`${base} ${styles} cursor-not-allowed select-none`}
            >
                {inner}
            </span>
        );
    }

    return (
        <a
            data-testid={testId}
            href={SITE.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`${base} ${styles}`}
        >
            {inner}
        </a>
    );
};

export default PlayStoreButton;
